


export class ProfileMenuView {
    constructor() {

        this.root = document.querySelector('.box.profile_menu');
        this.rootFloating = document.querySelector('#floating_menu');

        this.currentPath = window.location.pathname;
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        Object.entries(state?.data).forEach(([key, value]) => {

            const div = this.renderPartial(value);

            if (this.root) {

                const selector = '.li.dummy.' + value.class; // + '.active';
                const existingItem = this.root.querySelector(selector);
                if (existingItem) {
                    const parent = existingItem.parentElement;
                    parent.replaceChild(div, existingItem);
                }/* else {
                    profileMenu.appendChild(div);
                }*/

                if (this.isMenuActive(value.url)) { div.classList.add('active');}


                const selectorFloating = '.li.' + value.class;
                const existingItemFloating = this.rootFloating.querySelector(selectorFloating);
                if (existingItemFloating) {

                    const spanEm = existingItemFloating.querySelector('span.txt em');
                    if (spanEm) { spanEm.textContent = value.count;}
                }

            }
        });
    }

    renderPartial(data) {

        const div = document.createElement('div');
        div.classList.add('li', data.class);

        if (data?.dataMode) { div.setAttribute('data-mode', data.dataMode);}

        const link = document.createElement('a');
        link.href = data.url;

        const span = document.createElement('span');
        span.textContent = data.title;

        link.appendChild(span);

        const em = document.createElement('em');
        em.textContent = data.count;
        link.appendChild(em);

        div.appendChild(link);

        return div;
    }

    isMenuActive(menuFullUrl) {
        const normalize = path => path.replace(/\/+$/, "");
        const current = normalize(this.currentPath);
        const target = normalize(this.getPathFromUrl(menuFullUrl));

        if (target === "/") { return current === "/";}
        return current === target; // || current.startsWith(target + "/");
    }

    getPathFromUrl(fullUrl) {
        const url = new URL(fullUrl);
        return url.pathname.replace(/\/+$/, "");
    }
}